import { useTranslation } from 'next-i18next'
import Link from '../overwrites/Link'
import { LOCAL_SLUGS } from '../../lib/constants'

export function Contact() {
  const { i18n } = useTranslation('common')
  return (
    <Link
      href={'/' + LOCAL_SLUGS[0][i18n.language as AppLocale]}
      className="relative"
      aria-label="Contact"
    >
      <div className="cursor-pointer hover:text-primary flex items-center gap-2">
        <span className="text-xl far fa-envelope" />
      </div>
    </Link>
  )
}
